// import React from "react";
// import "../../assets/css/suggestion-list.css";
// import Loader from "./loaderOnlySpinner";

// function CustomDropDown({ optionData, classes, selectOption, hideOptions }) {
//   console.log("opt", optionData);
//   const closePopupHandler = () => {
//     hideOptions();
//   }
//   return (
//     <>
//       <div className={`filteredCompany w-100 ${classes ? classes : ""}`}>
//       {optionData.length !== 0 &&
//         <ul>
//           {optionData &&
//             optionData.map((value, index) => {
//               return (
//                 <li
//                   key={index}
//                   onClick={() =>
//                     selectOption({ value: value.value || value.INSTITUTE_ID, name: value.name || value.INSTITUTE_NAME})
//                   }
//                   data-value={value.value || value.INSTITUTE_ID}
//                 >
//                   {value.name || value.INSTITUTE_NAME}
//                 </li>
//               );
//             })}
//         </ul>
// }
//       </div>
//     </>
//   );
// }

// export default CustomDropDown;


import React, { useEffect, useRef } from "react";
import "../../assets/css/suggestion-list.css";
import Loader from "./loaderOnlySpinner";

function CustomDropDown({ optionData, classes, selectOption, hideOptions }) {
  const dropdownRef = useRef(null);

  const closePopupHandler = () => {
    if(hideOptions)
    hideOptions();
  };

  useEffect(() => {
    // Function to handle clicks outside the dropdown
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        closePopupHandler();
      }
    };

    // Add event listener for clicks
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div ref={dropdownRef} className={`filteredCompany w-100 ${classes ? classes : ""}`}>
      {optionData.length !== 0 && (
        <ul>
          {optionData.map((value, index) => (
            <li
              key={index}
              onClick={() =>
                selectOption({ value: value.value || value.INSTITUTE_ID || value.id, name: value.name || value.INSTITUTE_NAME || value.reason || value.designation })
              }
              data-value={value.value || value.INSTITUTE_ID || value.id}
            >
              {value.name || value.INSTITUTE_NAME || value.reason || value.designation}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomDropDown;
